/**
 * Nombres de plantilla que el Worker puede inyectar (subset usado en el cliente).
 *
 * Política: el home en todos los países es `WORKER_HOME_TEMPLATE` (cf. `cloudflare-worker-anaafernandez/worker.js`
 * → `COUNTRY_TEMPLATE_MAP`). La home por defecto usa `BaseTemplate` (fondo claro).
 *
 * `BaseTemplateBlack` es la variante oscura; solo aplica si el Worker la envía explícitamente.
 */

/** Template de home que inyecta el Worker para cualquier país (mapa + default). */
export const WORKER_HOME_TEMPLATE = "BaseTemplate" as const;

const BASE_TEMPLATE_FAMILY = new Set(["BaseTemplate", "BaseTemplateBlack"]);

export function isBaseTemplateFamily(templateName: string | null | undefined): boolean {
  return !!templateName && BASE_TEMPLATE_FAMILY.has(templateName);
}
